import { useTranslation } from "react-i18next";

const NotFound = () => {
    const { t } = useTranslation("translation");

    return (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
            <h1>{t("notFound.title")}</h1>
            <p>{t("notFound.description")}</p>
        </div>
    );
};

export default NotFound;